import { useTranslator } from 'components/shared/hooks';
import React, { FC } from 'react';

export interface DisplayCountProps {
  count: number;
  title: string;
}

/**
 * Status panel that displays a count from external source (e.g. form state).
 * Use when selection is not managed by the grid (e.g. form-driven checkboxes).
 */
export const DisplayCount: FC<DisplayCountProps> = ({ count, title }) => {
  const trans = useTranslator();

  if (count === 0) {
    return <div className="ag-name-value" />;
  }

  return (
    <div className="ag-name-value">{trans(title, { count })}</div>
  );
};
